'use client'

import { useState } from 'react'
import { H1 } from '@/General/H1'
import { Button } from '@/General/Button'
import { LoginModal } from '@/MainLayout/Header/TopMenu/LoginModal'

export default function RetrieveDownloadLogin({
  redirectTo = '/card',
}: {
  redirectTo?: string
}) {
  const [isLoginOpen, setIsLoginOpen] = useState(false)

  return (
    <>
      <section className="w-full rounded-md bg-gray-100 px-6 py-8 md:px-10 md:py-10">
        <H1 className="text-gray-900">Retrieve your download</H1>
        <p className="mt-4 max-w-3xl text-base text-gray-700">
          Your download must be added to a Vanishing Inc. account. If you have
          one, log in below. If not, please register for an account first.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Button type="button" onClick={() => setIsLoginOpen(true)} color="amber" size="lg">
            Log in to your account
          </Button>
          <Button href="/account/signup" color="dark" size="lg">
            Sign up
          </Button>
        </div>
      </section>
      <LoginModal
        isLoginOpen={isLoginOpen}
        setIsLoginOpen={setIsLoginOpen}
        message="Log in to retrieve your download."
        redirectTo={redirectTo}
      />
    </>
  )
}
